export enum ROLES {
    ADMINISTRADOR = "ROL_ADMINISTRADOR",
    DIRECTOR = "ROL_DIRECTOR",
    JEFE_DE_AREA = "ROL_JEFE_DE_AREA",
    AUDITOR = "ROL_AUDITOR",
    AUDITADO = "ROL_AUDITADO",
    VALIDADOR = "ROL_VALIDADOR",
    ASISTENTE = "ROL_ASISTENTE",
    ADMINISTRACION_GLOBAL = "ROL_ADMINISTRACION_GLOBAL",
    ADMINISTRACION_DIVISAS = "ROL_ADMINISTRACION_DIVISAS",
    ADMINISTRACION_ESTRUCTURAS = "ROL_ADMINISTRACION_ESTRUCTURAS",
    ADMINISTRACION_RHUMANOS = "ROL_ADMINISTRACION_RHUMANOS",
    ADMINISTRACION_USUARIOS = "ROL_ADMINISTRACION_USUARIOS",
    ADMINISTRACION_AEXTERNAS = "ROL_ADMINISTRACION_AEXTERNAS",
    ADMINISTRACION_CUESTIONARIOS = "ROL_ADMINISTRACION_CUESTIONARIOS",
    ADMINISTRACION_NOTICIAS = "ROL_ADMINISTRACION_NOTICIAS",
    ADMINISTRACION_PROCESOS = "ROL_ADMINISTRACION_PROCESOS",
    ADMINISTRACION_PROGRAMA_TRABAJOS = "ROL_ADMINISTRACION_PROGRAMA_TRABAJOS",
    FUNC_PAI = "ROL_FUNC_PAI",
    FUNC_TRABAJOS = "ROL_FUNC_TRABAJOS",
    FUNC_RRHH = "ROL_FUNC_RRHH",
    FUNC_PREV_PLANTILLA = "ROL_FUNC_PREV_PLANTILLA",
    FUNC_PRESUPUESTOS = "ROL_FUNC_PRESUPUESTOS",
    FUNC_GESTION = "ROL_FUNC_GESTION",
    ADMINISTRACION_MANTENIMIENTO = "ROL_ADMINISTRACION_MANTENIMIENTO"
}

export enum JOB_STATES {
    PLANIFICACION = "EN_PLANIFICACION",
    CURSO = "EN_CURSO",
    BORRADOR = "INFORME_BORRADOR",
    DEFINITIVO = "INFORME_DEFINITIVO"

}




